import { Component, input } from '@angular/core'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, Grid } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { GridColumnGroupComponent } from '../../shared/reusable-components/grid-column-group/grid-column-group.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { GridSelectionCalculationComponent } from '../../shared/reusable-components/grid-selection-calculation/grid-selection-calculation.component'
import { bindPurchasedMaterialTab, PurchasedMaterialFilters, purchasedMaterialScopeKey } from './purchased-material-filters'

interface EquipmentLine {
    description: string
    category: string
    lineCount: number
    spend: number
}

interface EquipmentRow {
    equipment: string
    description: string
    category: string
    status: string
    lineCount: number
    spend: number
    topItems: string
    lines: EquipmentLine[]
}

interface UnmatchedEquipmentRow {
    code: string
    example: string
    lineCount: number
    spend: number
}

@Component({
    selector: 'app-purchased-materials-equipment',
    templateUrl: './purchased-materials-equipment.component.html',
    standalone: true,
    imports: [
        ActionToolbarCount,
        GridExportComponent,
        GridColumnGroupComponent,
        WjGridModule,
        WjGridFilterModule,
        GridSelectionCalculationComponent,
    ],
})
export class PurchasedMaterialsEquipmentComponent extends BaseComponent {
    filters = input.required<PurchasedMaterialFilters>()
    active = input(false)

    unitGrid: Grid<EquipmentRow>
    lineGrid: Grid<EquipmentLine>
    unmatchedGrid: Grid<UnmatchedEquipmentRow>

    constructor() {
        super()
        this.unitGrid = new Grid<EquipmentRow>(this.services).wrapColumnHeaders()
        this.lineGrid = new Grid<EquipmentLine>(this.services).wrapColumnHeaders()
        this.unmatchedGrid = new Grid<UnmatchedEquipmentRow>(this.services).wrapColumnHeaders()
        bindPurchasedMaterialTab(
            this.filters,
            this.active,
            filters => purchasedMaterialScopeKey(filters, true),
            () => this.clear(),
            filters => this.load(filters),
        )
    }

    showLines() {
        const unit = this.unitGrid.selectedItem as EquipmentRow | null
        this.lineGrid.items = unit?.lines ?? []
    }

    private clear() {
        this.unitGrid.items = []
        this.lineGrid.items = []
        this.unmatchedGrid.items = []
    }

    private load(filters: PurchasedMaterialFilters) {
        this.cancelableRequest(
            'equipment',
            true,
            this.services.data
                .load(true, true, this.services.data.post('/api/PurchasedMaterials/GetEquipment', filters))
                .subscribe({
                    next: result => {
                        const payload = result[0]
                        this.unitGrid.items = payload.units ?? []
                        this.unmatchedGrid.items = payload.unmatched ?? []
                        this.showLines()
                    },
                }),
        )
    }
}
